import { qrConstants } from "../constants";

export const QrUid = (state = {}, action) => {
    switch (action.type) {
      case qrConstants.QR_UID_REQUEST:
        return { loading: true, items: undefined, error: undefined }
        
      case qrConstants.QR_UID_SUCCESS:
        return {
          loading: false,
          items: action.qruid.Body,
          error: undefined
        }
        
      case qrConstants.QR_UID_FAILURE:
        return { loading: false, items: undefined, error: action.error }
        
      default:
        return state
    }
  }

  export const QrUidData = (state = {}, action) => {
    switch (action.type) {
      case qrConstants.QR_DATA_REQUEST:
        return { loading: true, items: undefined, error: undefined }
        
      case qrConstants.QR_DATA_SUCCESS:
        return {
          loading: false,
          items: action.qruidData.Body,
          error: undefined
        }
        
      case qrConstants.QR_DATA_FAILURE:
        return { loading: false, items: undefined, error: action.error }
        
      default:
        return state
    }
  }

  export const AssociatedFile = (state = {}, action) => {
    switch (action.type) {
      case qrConstants.QR_FILE_REQUEST:
        return { loading: true, items: undefined, error: undefined }
        
      case qrConstants.QR_FILE_SUCCESS:
        return {
          loading: false,
          items: action.qrFile.Body,
          error: undefined
        }
        
      case qrConstants.QR_FILE_FAILURE:
        return { loading: false, items: undefined, error: action.error }
        
      default:
        return state
    }
  }